import { render } from "./EditShopTour.vue?vue&type=template&id=787b392a"
import script from "./EditShopTour.vue?vue&type=script&lang=js"
export * from "./EditShopTour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__